import request from '@/router/axios'


/**
 * 下载次数（7天、30天、本月）
 * @param params
 * @returns {*}
 */
export const getSystemStatisticsSummary = (params) => {
  return request({
    method: 'get',
    url: `/api/system_statistics/summary`,
    params: params
  })
}

/**
 * 系统下载次数（高到低，7天、30天、本月）
 * @param params
 * @returns {*}
 */
export const getSystemStatisticsTopFiles = (params) => {
  return request({
    method: 'get',
    url: `/api/system_statistics/topFiles`,
    params: params
  })
}

/**
 * 汇总曲线
 * @param params
 * @returns {*}
 */
export const getSystemStatisticsAllSummary = (params) => {
  return request({
    method: 'get',
    url: `/api/system_statistics/all_summary`,
    params: params
  })
}

/**
 * 系统下载次数（同比排序）
 * @param params
 * @returns {*}
 */
export const getSystemStatisticsTopFilesYoy = (params) => {
  return request({
    method: 'get',
    url: `/api/system_statistics/top_files_yoy`,
    params: params
  })
}

/**
 * 单个系统下载详情
 * @param params
 * @returns {*}
 */
export const getSystemStatisticsDetail = (params) => {
  return request({
    method: 'get',
    url: `/api/system_statistics_detailed/detail`,
    params: params
  })
}

/**
 * 单个系统下载详情-网盘数据
 * @param params
 * @returns {*}
 */
export const getSystemStatisticsDetailByDrive = (params) => {
  return request({
    method: 'get',
    url: `/api/system_statistics_detailed/detail_by_drive`,
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/SoftwareDownloads.js